import { FCC, getTheme, useBrandTheme } from "@dgs/core";
import { DefaultTheme, ThemeProvider } from "styled-components";
import { config } from "./config";
import { useConfig } from "./shared/hooks/useConfig";

const baseTheme = getTheme(config.mode);
const basePath = config.mode === "development" ? "/dev-assets" : "";
const theme = {
	...baseTheme,
	assets: {
		...baseTheme.assets,
		basePath,
	},
} as DefaultTheme;

export const PMThemeProvider: FCC = ({ children }) => {
	const { brand, apiUrl } = useConfig();
	const brandedTheme = useBrandTheme(config.themeName, theme, brand, apiUrl);

	return <ThemeProvider theme={brandedTheme}>{children}</ThemeProvider>;
};
